<template>
  <li
    v-if="canViewVerticalNavMenuLink(item) && checkAllowed(item)"
    class="nav-item"
    :class="{
      'active': isActive && !item.hideActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon v-if="!item.faIcon" :icon="item.icon || 'CircleIcon'" />
      <i v-if="item.faIcon" :class="item.faIcon"></i>
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
  import { mapState } from 'vuex';
  import { useUtils as useAclUtils } from '@core/libs/acl'
  import { BLink, BBadge } from 'bootstrap-vue'
  import { useUtils as useI18nUtils } from '@core/libs/i18n'
  import useVerticalNavMenuLink from './useVerticalNavMenuLink'
  import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

  export default {
    components: {
      BLink,
      BBadge,
    },
    mixins: [mixinVerticalNavMenuLink],
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState({
        digitalEnabled: state => state.auth.user.prison.purple_post_digital_enabled,
        printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
        repliesEnabled: state => state.auth.user.prison.purple_post_onsite_replies_enabled,
        physicalEnabled: state => state.auth.user.prison.purple_post_physical_enabled,
      }),
    },
    methods: {
      checkAllowed(item) {
        const check = item.userCheck && item.userCheck.length > 0;
        if (check) {
          let allowed = true;

          item.userCheck.forEach(itemC => {
            const checkLower = this[itemC.type] === itemC.value;
            if (!checkLower) {
              allowed = false;
            }
          });

          return allowed;
        }

        return true;
      },
    },
    setup(props) {
      const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
      const { t } = useI18nUtils()
      const { canViewVerticalNavMenuLink } = useAclUtils()

      return {
        isActive,
        linkProps,
        updateIsActive,

        // ACL
        canViewVerticalNavMenuLink,

        // i18n
        t,
      }
    },
  }
</script>
